import React from 'react';
import PropTypes from 'prop-types';
import control from '../../hocs/control/index';
//https://github.com/Lesha-spr/react-validation
const Textarea = ({ error, isUsed, ignoreShowErrorMsg, ...props }) => {
  var id = 'vali-' + props.name;
  let className = '';
  if (isUsed) {
    if (error && !ignoreShowErrorMsg) {
      className = `is-invalid-input ${props.className}`;
    } else {
      className = `is-valid-input ${props.className}`;
    }
  } else {
    className = `${props.className}`;
  }
  return <div className='textareaInput'>
    <textarea {...props}
      className={className} />
    {!ignoreShowErrorMsg && isUsed && error && <span id={id} className='cls-danger help-block' style={{marginBottom: -15}}>{error} </span>}
  </div>;
};

Textarea.propTypes = {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  isUsed: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string,
  ignoreShowErrorMsg: PropTypes.bool
};

export default control(Textarea);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/text-area/index.js